import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 3889,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 1018,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 319,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qzsdbunt_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zv4yrvzo_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7sinwzf6_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/41i8zlio_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rfg9dus6_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eldtqk1t_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xzy30gom_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yejy48ll_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6wfae6a0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hw6ga7tr_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7hve3ixw_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zh01ppnn_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/993q4peo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/br4zy6u8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m35ux4is_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ezttuqsb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ngcl57ga_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input1}
								onChange={(event)=>onChangeInput1(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/waydxa4n_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2omjb6u1_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sfwktpa5_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Mentors"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 38,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 42,
							}} >
							{"Explore all mentors"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Mentors"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #00AEEF`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4rqypof3_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 105,
											}} >
											{"Jenny Wilson"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/twnhyx74_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wnvpfz3q_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fnxxhtqz_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7b3sz1tf_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/l2tuf7do_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#EEBD10",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Limited Availability"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 108,
											}} >
											{"Guy Hawkins"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xkht7v4v_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/aeez2qvz_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vt04gdat_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/b93hokvu_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9h78bmez_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FF3737",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Unavailable"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 126,
											}} >
											{"Robert Fox"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/axkde5ko_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6pijjeq3_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ovq338gd_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jh8jzxza_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2j16p3zw_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 97,
											}} >
											{"Bessie Cooper"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tk4nht25_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eo24hljz_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jwurryh0_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0tlg9c8c_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1147,
								background: "#E6E6E6",
								marginRight: 19,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
									marginLeft: 4,
								}} >
								{"Mentor Profile"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
									marginLeft: 4,
									marginRight: 4,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 29,
									marginLeft: 4,
									gap: 20,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										position: "relative",
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jq8v8jok_expires_30_days.png"} 
										style={{
											width: 80,
											height: 80,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											position: "absolute",
											bottom: -6,
											left: 12,
											width: 56,
											display: "flex",
											flexDirection: "column",
											background: "#0BBB0D",
											borderRadius: 4,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 10,
												fontWeight: "bold",
												textAlign: "center",
												marginTop: 2,
												marginBottom: 2,
												marginLeft: 6,
												marginRight: 6,
											}} >
											{"Available"}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginBottom: 8,
										}} >
										{"Jenny Wilson"}
									</span>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											paddingRight: 1,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fg1t5rho_expires_30_days.png"} 
											style={{
												width: 12,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"New York City, USA"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
									marginLeft: 4,
									marginRight: 4,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#1074BC",
									borderRadius: 8,
									paddingTop: 13,
									marginBottom: 20,
									marginLeft: 4,
									marginRight: 4,
									gap: 9,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 35,
										marginRight: 35,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
											marginRight: 49,
										}} >
										{"Expertise"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											marginRight: 46,
										}} >
										{"Experience"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											fontWeight: "bold",
											marginTop: 1,
											marginBottom: 1,
										}} >
										{"Availability"}
									</span>
								</div>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-end",
									}}>
									<div 
										style={{
											width: 65,
											height: 3,
											background: "#FFFFFF",
											borderTopLeftRadius: 8,
											borderTopRightRadius: 9,
											marginRight: 31,
											boxShadow: "0px 1px 2px #00000012",
										}}>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										paddingBottom: 13,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-end",
											gap: 11,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 18,
													fontWeight: "bold",
													marginRight: 172,
												}} >
												{"07 April 2025"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z4rhkt46_expires_30_days.png"} 
												style={{
													width: 24,
													height: 24,
													marginRight: 15,
													objectFit: "fill",
												}}
											/>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4tvozp9o_expires_30_days.png"} 
												style={{
													width: 24,
													height: 24,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 1,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 12,
														marginRight: 13,
														width: 20,
													}} >
													{"Mo"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 15,
													}} >
													{"Tu"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 21,
													}} >
													{"We"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 17,
													}} >
													{"Th"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 26,
														width: 12,
													}} >
													{"Fr"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 16,
													}} >
													{"Sa"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 13,
														width: 16,
													}} >
													{"Su"}
												</span>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 1,
												}}>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 12,
														paddingRight: 33,
														marginRight: 1,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 4,
														}} >
														{"1"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 13,
														paddingRight: 29,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 7,
														}} >
														{"2"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 13,
														paddingRight: 29,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 7,
														}} >
														{"3"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 13,
														paddingRight: 28,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 8,
														}} >
														{"4"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 13,
														paddingRight: 29,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 7,
														}} >
														{"5"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														paddingLeft: 13,
														paddingRight: 29,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#6C6C6C",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 7,
														}} >
														{"6"}
													</span>
												</div>
												<input
													placeholder={"7"}
													value={input2}
													onChange={(event)=>onChangeInput2(event.target.value)}
													style={{
														color: "#FFFFFF",
														fontSize: 15,
														fontWeight: "bold",
														flexShrink: 0,
														background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
														borderRadius: 1000,
														border: `1px solid #00000000`,
														padding: 13,
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 1,
													marginBottom: 1,
												}}>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														marginRight: 1,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															marginLeft: 12,
															width: 7,
														}} >
														{"8"}
													</span>
													<div 
														style={{
															alignSelf: "stretch",
															display: "flex",
															flexDirection: "column",
															alignItems: "center",
														}}>
														<img
															src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/khcbzt63_expires_30_days.png"} 
															style={{
																width: 8,
																height: 8,
																objectFit: "fill",
															}}
														/>
													</div>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 13,
														paddingBottom: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															marginLeft: 13,
															width: 7,
														}} >
														{"9"}
													</span>
													<div 
														style={{
															alignSelf: "stretch",
															display: "flex",
															flexDirection: "column",
															alignItems: "center",
														}}>
														<img
															src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rak9mlej_expires_30_days.png"} 
															style={{
																width: 8,
																height: 8,
																objectFit: "fill",
															}}
														/>
													</div>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														border: `1px solid #00000000`,
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"10"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jb2iqxqv_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 14,
														}} >
														{"11"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"12"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"13"}
													</span>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														padding: 13,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"14"}
													</span>
												</div>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													paddingRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 12,
														marginRight: 13,
														width: 16,
													}} >
													{"15"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 16,
													}} >
													{"16"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 15,
														width: 16,
													}} >
													{"17"}
												</span>
												<button 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														background: "none",
														borderRadius: 39,
														border: `1px solid #00000000`,
														paddingTop: 11,
														paddingBottom: 11,
														paddingLeft: 12,
														paddingRight: 12,
														marginRight: 3,
														textAlign: "left",
													}}
													onClick={()=>alert("Pressed!")}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"18"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cq63yam7_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</button>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														borderRadius: 40,
														padding: 12,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"19"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2sr2fsr4_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														borderRadius: 40,
														padding: 12,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"20"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zfumhydu_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														margin: 12,
														width: 15,
													}} >
													{"21"}
												</span>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 1,
													marginBottom: 1,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 13,
														marginBottom: 13,
														marginLeft: 12,
														marginRight: 13,
														width: 17,
													}} >
													{"22"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"23"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8rr5vbnq_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"24"}
													</span>
													<div 
														style={{
															alignSelf: "stretch",
															display: "flex",
															flexDirection: "column",
															alignItems: "flex-end",
														}}>
														<img
															src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z29nr07a_expires_30_days.png"} 
															style={{
																width: 8,
																height: 8,
																objectFit: "fill",
															}}
														/>
													</div>
												</div>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 13,
														marginBottom: 13,
														marginLeft: 13,
														marginRight: 15,
														width: 17,
													}} >
													{"25"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"26"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zwicgqi7_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														padding: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 16,
														}} >
														{"27"}
													</span>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dqe7obpo_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														margin: 13,
														width: 17,
													}} >
													{"28"}
												</span>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 1,
												}}>
												<button 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "none",
														borderRadius: 1000,
														border: `1px solid #00000000`,
														padding: 12,
														marginRight: 1,
														textAlign: "left",
													}}
													onClick={()=>alert("Pressed!")}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"29"}
													</span>
												</button>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														border: `1px solid #00000000`,
														paddingTop: 12,
														paddingBottom: 12,
														paddingLeft: 13,
														paddingRight: 13,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															width: 17,
														}} >
														{"30"}
													</span>
												</div>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 34,
														width: 4,
													}} >
													{"1"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 31,
														width: 7,
													}} >
													{"2"}
												</span>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginTop: 12,
														marginBottom: 12,
														marginLeft: 13,
														marginRight: 31,
														width: 7,
													}} >
													{"3"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														paddingTop: 12,
														paddingBottom: 12,
														marginRight: 2,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															marginLeft: 13,
															width: 8,
														}} >
														{"4"}
													</span>
													<div 
														style={{
															alignSelf: "stretch",
															display: "flex",
															flexDirection: "column",
															alignItems: "center",
														}}>
														<img
															src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mkhescbk_expires_30_days.png"} 
															style={{
																width: 8,
																height: 8,
																objectFit: "fill",
															}}
														/>
													</div>
												</div>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														paddingTop: 12,
														paddingBottom: 12,
													}}>
													<span 
														style={{
															color: "#010101",
															fontSize: 15,
															fontWeight: "bold",
															textAlign: "center",
															marginLeft: 13,
															width: 7,
														}} >
														{"5"}
													</span>
													<div 
														style={{
															alignSelf: "stretch",
															display: "flex",
															flexDirection: "column",
															alignItems: "center",
														}}>
														<img
															src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lsm87tf5_expires_30_days.png"} 
															style={{
																width: 8,
																height: 8,
																objectFit: "fill",
															}}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div 
									style={{
										width: 362,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 23,
									}}>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 16,
									}} >
									{"Available time slots"}
								</span>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 20,
										gap: 20,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 2,
											gap: 6,
										}}>
										<div 
											style={{
												width: 11,
												height: 11,
												background: "#0BBB0D",
												borderRadius: 2,
											}}>
										</div>
										<span 
											style={{
												color: "#000000",
												fontSize: 12,
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 3,
											gap: 6,
										}}>
										<div 
											style={{
												width: 11,
												height: 11,
												background: "#1074BC",
												borderRadius: 2,
											}}>
										</div>
										<span 
											style={{
												color: "#000000",
												fontSize: 12,
											}} >
											{"Booked"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 3,
											gap: 6,
										}}>
										<div 
											style={{
												width: 11,
												height: 11,
												background: "#979797",
												borderRadius: 2,
											}}>
										</div>
										<span 
											style={{
												color: "#000000",
												fontSize: 12,
											}} >
											{"Unavailable"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginBottom: 24,
										gap: 12,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											gap: 12,
										}}>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
												}} >
												{"10:00 - 11:00"}
											</span>
										</button>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
												}} >
												{"11:00 - 12:00"}
											</span>
										</button>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 14,
												}} >
												{"13:00 - 14:00"}
											</span>
										</button>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											gap: 12,
										}}>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #1074BC`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#1074BC",
													fontSize: 14,
												}} >
												{"14:00 - 15:00"}
											</span>
										</button>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 14,
												}} >
												{"15:00 - 16:00"}
											</span>
										</button>
										<button 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "none",
												borderRadius: 8,
												border: `1px solid #1074BC`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 12,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#1074BC",
													fontSize: 14,
												}} >
												{"17:00 - 18:00"}
											</span>
										</button>
									</div>
								</div>
								<div 
									style={{
										width: 362,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 23,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 21,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
											marginRight: 128,
										}} >
										{"Time Zone Conversion"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 5,
										}}>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Select"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zmbhdqoz_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 17,
									}}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 99,
										}} >
										{"View in Mentor's Time Zone (PST)"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											alignItems: "flex-start",
											background: "#1074BC",
											borderRadius: 74,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 16,
											paddingRight: 1,
										}}>
										<div 
											style={{
												width: 20,
												height: 20,
												background: "#FFFFFF",
												borderRadius: 74,
												boxShadow: "0px 2.225806474685669px 0px #0000000D",
											}}>
										</div>
									</div>
								</div>
								<input
									placeholder={"Your time zone is South Africa (GMT+2)"}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#1074BC",
										fontSize: 14,
										fontWeight: "bold",
										marginBottom: 20,
										background: "#E7F1F8",
										borderRadius: 5,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
									}}
								/>
								<div 
									style={{
										width: 362,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 31,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #00000000`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 109,
										paddingRight: 111,
										marginBottom: 12,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jixvk401_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Schedule Meeting"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 8,
										border: `1px solid #00000000`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 82,
										paddingRight: 83,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ezrbu5r1_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Send Connection Request"}
									</span>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1147,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 11,
									gap: 46,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Send Connection Request"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/he31jjic_expires_30_days.png"} 
									style={{
										width: 10,
										height: 10,
										marginTop: 13,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Learning Goals:"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Goal"}
								</span>
								<input
									placeholder={"Select goal"}
									value={input4}
									onChange={(event)=>onChangeInput4(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginBottom: 20,
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 20,
										paddingRight: 20,
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Description (optional)"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 67,
										paddingLeft: 20,
										paddingRight: 136,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
										}} >
										{"Enter description..."}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Areas of Interest:"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 50,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											width: 230,
										}} >
										{"How to secure seed funding for my startup?"}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
										width: 196,
									}} >
									{"Preferred Communication Frequency:"}
								</span>
								<button 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 15,
										paddingBottom: 15,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
											marginRight: 118,
										}} >
										{"Select frequency"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/msn85axt_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
								</button>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 8,
										border: `1px solid #00000000`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 40,
										paddingRight: 41,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i4hsy0ob_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Send Connection Request"}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
						}}>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7xig8zng_expires_30_days.png"} 
							style={{
								width: 7,
								height: 17,
								objectFit: "fill",
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}